import React, { useEffect, useState, useMemo } from "react"
import PropTypes from "prop-types"
import withRouter from "components/Common/withRouter"

import {
  Card,
  CardBody,
  Col,
  Modal,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"
import classnames from "classnames"

// import {
//   OrderId,
//   BillingName,
//   Date,
//   Total,
//   PaymentStatus,
//   PaymentMethod,
// } from "./LatestTranactionCol"
import { Link } from "react-router-dom"
import { CommonTableContainer } from "common/utils/ComonTableContainer"
import moment from "moment"
import configure from "configure"

const projectStatus = [
    { label: "Not Started", value: "0" },
    { label: "In Progress", value: "1" },
    { label: "On Hold", value: "2" },
    { label: "Cancelled", value: "3" },
    { label: "Finished", value: "4" },
]

const MyProjects = ({inprogress_projects}) => {

  const [modal1, setModal1] = useState(false)
  const [viewProjectPopup, setViewProjectPopup] = useState(false)
  const [verticalActiveTab, setverticalActiveTab] = useState("1")
  const [projectData, setProjectData] = useState(null)
  const toggleViewModal = () => setModal1(!modal1)

  useEffect(()=>{
    if(inprogress_projects.length > 0){
      setProjectData(inprogress_projects[0])
    }
  },[inprogress_projects])



  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "Id",
        filterable: false,
        disableFilters: true,
        className:"id text-center",
        Cell: cellProps => {
          return (
            <div className="text-center">{cellProps.row.original.id}</div>
          )
        }
      },
      {
        Header: "Project Name",
        accessor: "project_name",
        filterable: false,
        disableFilters: true,
        className :"project_name",
        Cell: cellProps =>{
          return(
            <div className="text-start">{cellProps.row.original.project_name || "-"}</div>
          )
        }
      },
      {
        Header: "Customer",
        accessor: "customer",
        disableFilters: true,
        filterable: false,
        className :"customer text-center",
        Cell: cellProps =>{
          return(
            <div className="text-start">{cellProps.row.original.customerDetails?.company || "-"}</div>
          )
        }
      },
      {
        Header: "Start Date",
        accessor: "start_date",
        disableFilters: true,
        filterable: false,
        className: "start_date text-center",
        Cell: cellProps =>{
          return(
            <div className="text-center">{cellProps.row.original.startdate ? moment(cellProps.row.original.startdate.slice(0,10)).format("DD-MM-YYYY") : "-"}</div>
          )
        }
      },
      {
        Header: "Status",
        accessor: "status",
        disableFilters: true,
        filterable: false,
        className : "status text-center",
        Cell: cellProps =>{
          return(
            <div className="text-center">{projectStatus.filter(item => item.value === cellProps.row.original.status)[0]?.label || "-"}</div>
          )
        }
      },
    ],
    []
  )

  return (
    <React.Fragment>
      {/* <EcommerceOrdersModal isOpen={modal1} toggle={toggleViewModal} /> */}
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">Projects</div>
          <CommonTableContainer
            columns={columns}
            // data={setProjectData}
            data={inprogress_projects}
            isGlobalFilter={false}
            isAddOptions={false}
            customPageSize={6}
          />
        </CardBody>
      </Card>

        {/* View Project  */}
      <Modal
        size="xl"
        isOpen={viewProjectPopup}
        className="modal-fullscreen"
      >
        <div className="modal-header mb-0">
          <div
            className="d-flex align-items-center justify-content-between"
            style={{ width: "100%" }}
          >
            <h5 className="col-6 modal-title mt-0">View Project Details</h5>
          </div>

          <button
            type="button"
            onClick={() => {
                setViewProjectPopup(false)
            }}
            className="ms-4"
            style={{ border: "none", backgroundColor: "transparent" }}
          >
            <span
              aria-hidden="true"
              style={{ color: "#bf1e30", fontSize: "28px", lineHeight: "1px" }}
            >
              {" "}
              &times;{" "}
            </span>
          </button>
        </div>

        <div className="modal-body hide-bottom-scrollbar ps-3 pe-0 pt-0">
          <Row className="gx-4 justify-content-between">
            <Col md="2" className="side-tab h-100 py-3 bd-fixed-sidetab">
              <Nav pills className="flex-column">
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "1",
                    })}
                  >
                    Basic Project Details
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "2",
                    })}
                  >
                    Notes
                  </NavLink>
                </NavItem>
              
              
              </Nav>
            </Col>
            <Col md="10" className="bd-right-side-tab">
              <div className="px-4 h-100 pl-0">
                <TabContent
                  activeTab={verticalActiveTab}
                  className="text-muted mt-4 mt-md-0"
                >
                  <TabPane tabId="1">
                   
                  </TabPane>
                  <TabPane tabId="2">
                    
                  </TabPane>
                  
                </TabContent>
              </div>
            </Col>
          </Row>
        </div>
      </Modal>
    </React.Fragment>
  )
}

MyProjects.propTypes = {
  orders: PropTypes.array,
  onGetOrders: PropTypes.func,
}

export default withRouter(MyProjects)
